// src/pages/RegistrationPage.tsx
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Building2, Truck } from 'lucide-react';

const RegistrationPage = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gray-50 flex flex-col justify-center py-12 sm:px-6 lg:px-8">
      <div className="sm:mx-auto sm:w-full sm:max-w-md">
        <h2 className="mt-6 text-center text-3xl font-extrabold text-gray-900">
          Create Your Account
        </h2>
        <p className="mt-2 text-center text-sm text-gray-600">
          Choose how you want to register
        </p>
      </div>

      <div className="mt-8 sm:mx-auto sm:w-full sm:max-w-md">
        <div className="bg-white py-8 px-4 shadow sm:rounded-lg sm:px-10 space-y-4">
          
          {/* Carrier Registration Button */}
          <button
            onClick={() => navigate('/register/carrier')}
            className="w-full flex items-center justify-center gap-3 px-6 py-4 border-2 border-blue-600 bg-blue-600 text-white rounded-lg hover:bg-blue-700 hover:border-blue-700 transition-colors"
          >
            <Truck className="h-6 w-6" />
            <div className="text-left">
              <div className="font-semibold text-lg">I'm a Carrier</div>
              <div className="text-sm text-blue-100">Join a broker with their invite code</div>
            </div>
          </button>

          {/* Broker Registration Button */}
          <button
            onClick={() => navigate('/register/broker')}
            className="w-full flex items-center justify-center gap-3 px-6 py-4 border-2 border-green-600 bg-green-600 text-white rounded-lg hover:bg-green-700 hover:border-green-700 transition-colors"
          >
            <Building2 className="h-6 w-6" />
            <div className="text-left">
              <div className="font-semibold text-lg">I'm a Broker</div>
              <div className="text-sm text-green-100">Start onboarding carriers</div>
            </div>
          </button>

          {/* Login Link */}
          <div className="mt-6 text-center pt-4 border-t border-gray-200">
            <p className="text-sm text-gray-600">
              Already have an account?{' '}
              <a href="/login" className="text-blue-600 hover:underline font-medium">
                Log in
              </a>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RegistrationPage;